import { useHistory } from "react-router";
import { routes } from "../../../constants"
import { BdInventoryViewType } from "../../../selectors/dealer-inventory.selector"
import { TabItem, TabList } from "../../bidding/common/tab-list"

export interface Props {
    activateTab?: BdInventoryViewType
}

export function BdInventoryTabList({ activateTab = BdInventoryViewType.All }: Props) {
    const history = useHistory();

    return (
        <TabList>
            <TabItem active={activateTab === BdInventoryViewType.All} title="All" path={routes.bdInventoryUrl() + history.location.search} />
            <TabItem active={activateTab === BdInventoryViewType.Public} title="Public" path={routes.bdInventoryUrl(BdInventoryViewType.Public + history.location.search)} />
            <TabItem active={activateTab === BdInventoryViewType.Private} title="Private" path={routes.bdInventoryUrl(BdInventoryViewType.Private + history.location.search)} />
        </TabList>
    )
}